/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkDecisionRequestBidirectionalActionDetailsDetails } from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetails';
import {
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSON,
} from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetails';

/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequestBidirectionalActionDetails
 */
export interface InstanceBulkDecisionRequestBidirectionalActionDetails {
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetails
     */
    action: InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum;
    /**
     * 
     * @type {InstanceBulkDecisionRequestBidirectionalActionDetailsDetails}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetails
     */
    details?: InstanceBulkDecisionRequestBidirectionalActionDetailsDetails;
}


/**
 * @export
 */
export const InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum = {
    Accept: 'Accept',
    Decline: 'Decline',
    RequestInformation: 'RequestInformation',
    ReferralReceived: 'ReferralReceived'
} as const;
export type InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum = typeof InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum[keyof typeof InstanceBulkDecisionRequestBidirectionalActionDetailsActionEnum];


/**
 * Check if a given object implements the InstanceBulkDecisionRequestBidirectionalActionDetails interface.
 */
export function instanceOfInstanceBulkDecisionRequestBidirectionalActionDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetails {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequestBidirectionalActionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': json['action'],
        'details': !exists(json, 'details') ? undefined : InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json['details']),
    };
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsToJSON(value?: InstanceBulkDecisionRequestBidirectionalActionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'details': InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSON(value.details),
    };
}

